import { applySystemEdit } from 'layout/widgets/adaChat/utils/applySystemEdit'
import type { SystemEditOperation } from 'layout/widgets/adaChat/utils/systemEditSchema'
import { validateActionRequirementsOrThrow } from 'layout/widgets/adaChat/utils/validateActionRequirements'
import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface SystemEditArgs {
  operations: SystemEditOperation[]
  confirmed?: boolean
}

export const TOOL_NAME = 'system_edit'

export async function SystemEditToolCall(functionCall: LiveFunctionCall, history: any, orgId: number | undefined) {
  const args = functionCall.args as SystemEditArgs

  console.log('[Voice] SystemEditToolCall', args)

  const pathname = window.location.pathname
  validateActionRequirementsOrThrow('systemEdit', pathname)

  if (!args.operations || !Array.isArray(args.operations) || args.operations.length === 0) {
    throw new Error('System edit requires at least one operation')
  }

  try {
    await applySystemEdit(args.operations)

    return {
      success: true,
      message: `Applied ${args.operations.length} system edit operation(s) successfully`,
    }
  } catch (error: any) {
    console.error('[Voice] System edit error:', error)
    throw error
  }
}
